import { clsx } from 'clsx';

import { getCardUrl } from '../hooks/getCardUrl';

type DeckCardImageProps = {
  className?: string;
  slug: string;
  deckSlug?: string | undefined;
  name: string;
} & React.ImgHTMLAttributes<HTMLImageElement>;

export const DeckCardImage = ({ className, slug, deckSlug, name, ...rest }: DeckCardImageProps) => (
  <img
    className={clsx('rounded-lg shadow bg-surface-sunken', className)}
    src={getCardUrl({ slug, deckSlug })}
    alt={name}
    {...rest}
  />
);
